import React, { useEffect, useState } from 'react';
import useAuthHeader from 'react-auth-kit/hooks/useAuthHeader';
import AddMunicipality from '../components/AddMunicipality';
import EditMunicipality from '../components/EditMunicipality';
import { getMunicipality } from '../hooks/GetMunicipality';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { setMunicipality } from '../redux/municipialitySlice';
import useIsAuthenticated from 'react-auth-kit/hooks/useIsAuthenticated';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';

export default function MunicipalityPage() {
  const isAuthenticated = useIsAuthenticated();
  const auth: string = useAuthHeader() || '';
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const municipality = useSelector(
    (state: RootState) => state.municipality.selectedMunicipality
  );
  const [isInitializing, setIsInitializing] = useState(true);

  useEffect(() => {
    if (isAuthenticated === false) {
      navigate('/login');
    }
  }, [isAuthenticated, navigate]);

  useEffect(() => {
    if (!auth) return;

    const initMunicipality = async () => {
      if (!municipality) {
        const fetchedMunicipality = await getMunicipality(auth, dispatch);
        if (fetchedMunicipality) {
          dispatch(setMunicipality(fetchedMunicipality));
        }
      }

      setIsInitializing(false);
    };

    initMunicipality();
  }, [auth, dispatch]);

  if (isInitializing || (!auth && isAuthenticated)) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return <>{municipality?.name ? <EditMunicipality /> : <AddMunicipality />}</>;
}
